'use strict';

var batcher = require('./batcher.cjs');
var noop = require('../../../../motion-utils/dist/es/noop.cjs');

const { schedule: frame, cancel: cancelFrame, state: frameData, steps: frameSteps, } = /* @__PURE__ */ batcher.createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop.noop, true);

exports.cancelFrame = cancelFrame;
exports.frame = frame;
exports.frameData = frameData;
exports.frameSteps = frameSteps;
//# sourceMappingURL=frame.cjs.map
